import { formatRoDate } from "./dates";

// Iter65b — QC PPC: aceeași interpretare în antet și în cardul Overview.
// Lipsa datei NU înseamnă „neefectuat"; nu inventăm rezultat sau dată.
export const qcHelper = (outcome, dateVal) => {
  const d = formatRoDate(dateVal);
  if (outcome && d) return `Rezultat înregistrat · data apelului: ${d}`;
  if (outcome && !d) return "Rezultat înregistrat · data apelului: neînregistrată";
  if (!outcome && d) return `Apel la ${d} · rezultat neînregistrat`;
  return "Niciun rezultat și nicio dată înregistrate (nu înseamnă că apelul nu a fost efectuat)";
};
